import {
  ChartOrderBy,
  DisplayAggregateQuestionDto,
  DisplayIndividualQuestionDto,
} from '@keyops-cep/api-client';
import { Chart } from 'chart.js';
import { toBlob } from 'html-to-image';

export const downloadGraph = (
  name: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartRef: { current: Chart<any, any, any> | null }
) => {
  if (chartRef.current) {
    const imageDataUrl = chartRef.current.toBase64Image();
    const link = document.createElement('a');
    link.download = `${name}.png`;
    link.href = imageDataUrl;
    link.click();
  }
};
export const copyGraph = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartRef: { current: Chart<any, any, any> | null }
) => {
  if (chartRef.current) {
    const canvas = chartRef.current.canvas;
    if (canvas) {
      toBlob(canvas)
        .then(async (blob) => {
          try {
            if (blob) {
              const item = new ClipboardItem({ 'image/png': blob });
              await navigator.clipboard.write([item]);
              console.log('Image copied to clipboard');
            }
          } catch (error) {
            console.error(error);
          }
        })
        .catch((error) => {
          console.error('oops, something went wrong!', error);
        });
    }
  }
};

export const buildQuestionMetadataForUpsert = (
  editableQuestion: DisplayIndividualQuestionDto | DisplayAggregateQuestionDto,
  label: string
) => {
  return {
    orderBy:
      editableQuestion?.displayConfig?.orderBy ?? ('INITIAL' as ChartOrderBy),
    // explicitly set to null if empty string to clear existing titles
    chartTitle:
      editableQuestion.displayConfig?.chartTitle === ''
        ? null
        : editableQuestion.displayConfig?.chartTitle,
    xAxisTitle:
      editableQuestion.displayConfig?.xAxisTitle === ''
        ? null
        : editableQuestion.displayConfig?.xAxisTitle,
    yAxisTitle:
      editableQuestion.displayConfig?.yAxisTitle === ''
        ? null
        : editableQuestion.displayConfig?.yAxisTitle,
    // if label is empty, revert to originalLabel
    questionLabel: label === '' ? editableQuestion.originalLabel : label,
    externalQuestionId: editableQuestion.surveySparrowId,
    engagementId: editableQuestion.engagementId,
    tenantId: editableQuestion.tenantId,
  };
};
